const items = [
  "Cagnone",
  "Panissa",
  "Agnolotti al Sugo d'Arrosto",
  "Bollito Misto",
  "Brasato al Vino con Polenta",
  "Bonet",
  "Panna Cotta",
  "Meringata con Cioccolato Fondente",
];

const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="border-y border-[#E7E4DF] py-6 overflow-hidden select-none" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-serif-display text-2xl sm:text-3xl italic text-[#1C1917]/80">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#D99B26]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
